import React, { useEffect, useRef } from "react";
import p5 from "p5";

const GridAnimation = () => {
  const sketchRef = useRef(null);

  useEffect(() => {
    const sketch = (p) => {
      // CONSTANTS
      const CELL_SIZE = 30;
      const COLOR_R = 92;
      const COLOR_G = 72;
      const COLOR_B = 17;
      const STARTING_ALPHA = 200;
      const AMT_FADE_PER_FRAME = 6;

      // VARIABLES
      let colorWithAlpha;
      let numRows;
      let numCols;
      let currentRow = -1;
      let currentCol = -1;
      let allNeighbors = [];
      let canvas;
      let parentBounds;

      p.setup = () => {
        // Get parent bounds
        const parentDiv = sketchRef.current;
        parentBounds = parentDiv.getBoundingClientRect();

        // Create a canvas and attach it to the parent div
        canvas = p.createCanvas(parentBounds.width, parentBounds.height);
        canvas.parent(parentDiv);
        canvas.style("z-index", 100);

        colorWithAlpha = p.color(COLOR_R, COLOR_G, COLOR_B, STARTING_ALPHA);
        p.noFill();
        p.stroke(colorWithAlpha);
        p.strokeWeight(1);

        numRows = Math.ceil(parentBounds.height / CELL_SIZE);
        numCols = Math.ceil(parentBounds.width / CELL_SIZE);
      };

      p.draw = () => {
        p.clear();

        // Get the mouse position relative to the canvas
        const mouseX = p.mouseX;
        const mouseY = p.mouseY;

        // Check if the mouse is inside the canvas
        if (
          mouseX >= 0 &&
          mouseY >= 0 &&
          mouseX < p.width &&
          mouseY < p.height
        ) {
          // Calculate the grid cell under the mouse
          const row = Math.floor(mouseY / CELL_SIZE);
          const col = Math.floor(mouseX / CELL_SIZE);

          if (row !== currentRow || col !== currentCol) {
            currentRow = row;
            currentCol = col;
            allNeighbors.push(...getRandomNeighbors(row, col));
          }

          const x = col * CELL_SIZE;
          const y = row * CELL_SIZE;

          // Highlight the cell under the mouse
          p.stroke(colorWithAlpha);
          p.rect(x, y, CELL_SIZE, CELL_SIZE);

          // Update and draw neighbors
          for (const neighbor of allNeighbors) {
            const neighborX = neighbor.col * CELL_SIZE;
            const neighborY = neighbor.row * CELL_SIZE;
            neighbor.opacity = Math.max(
              0,
              neighbor.opacity - AMT_FADE_PER_FRAME
            );
            p.stroke(COLOR_R, COLOR_G, COLOR_B, neighbor.opacity);
            p.rect(neighborX, neighborY, CELL_SIZE, CELL_SIZE);
          }

          // Remove neighbors with zero opacity
          allNeighbors = allNeighbors.filter((n) => n.opacity > 0);
        }
      };

      const getRandomNeighbors = (row, col) => {
        const neighbors = [];
        for (let dRow = -1; dRow <= 1; dRow++) {
          for (let dCol = -1; dCol <= 1; dCol++) {
            const neighborRow = row + dRow;
            const neighborCol = col + dCol;
            const isCurrentCell = dRow === 0 && dCol === 0;
            const isInBounds =
              neighborRow >= 0 &&
              neighborRow < numRows &&
              neighborCol >= 0 &&
              neighborCol < numCols;

            if (!isCurrentCell && isInBounds && Math.random() < 0.5) {
              neighbors.push({
                row: neighborRow,
                col: neighborCol,
                opacity: 255,
              });
            }
          }
        }
        return neighbors;
      };

      p.windowResized = () => {
        const parentDiv = sketchRef.current;
        parentBounds = parentDiv.getBoundingClientRect();
        p.resizeCanvas(parentBounds.width, parentBounds.height);

        numRows = Math.ceil(parentBounds.height / CELL_SIZE);
        numCols = Math.ceil(parentBounds.width / CELL_SIZE);
      };
    };

    // Create a new p5 instance
    const p5Instance = new p5(sketch);

    return () => {
      p5Instance.remove();
    };
  }, []);

  return (
    <div
      ref={sketchRef}
      style={{ position: "relative", width: "100%", height: "100%" }}
    />
  );
};

export default GridAnimation;





































// import React, { useEffect, useRef } from "react";
// import p5 from "p5";

// const GridAnimation = () => {
//   const sketchRef = useRef(null);

//   useEffect(() => {
//     const sketch = (p) => {
//       // CONSTANTS
//       const CELL_SIZE = 40;
//       const COLOR_R = 128;
// const COLOR_G = 128;
// const COLOR_B = 128;
//       const STARTING_ALPHA = 200;
//       const PROB_OF_NEIGHBOR = 0.5;
//       const AMT_FADE_PER_FRAME = 5;

//       // VARIABLES
//       let colorWithAlpha;
//       let numRows;
//       let numCols;
//       let parentBounds; // To store the parent div's dimensions and position
//       let currentRow = -2;
//       let currentCol = -2;
//       let allNeighbors = [];

//       p.setup = () => {
//         // Get parent div dimensions
//         const parentDiv = sketchRef.current.parentNode;
//         parentBounds = parentDiv.getBoundingClientRect();

//         const cnv = p.createCanvas(parentBounds.width, parentBounds.height);
//         cnv.style("position", "absolute");
//         cnv.style("top", 0);
//         cnv.style("left", 0);
//         cnv.style("z-index", 100);
//         cnv.style("pointer-events", "none"); // Prevent interference with other elements
//         cnv.style("background", "transparent"); // Transparent background

//         colorWithAlpha = p.color(COLOR_R, COLOR_G, COLOR_B, STARTING_ALPHA);
//         p.noFill();
//         p.stroke(colorWithAlpha);
//         p.strokeWeight(1);

//         numRows = Math.ceil(parentBounds.height / CELL_SIZE);
//         numCols = Math.ceil(parentBounds.width / CELL_SIZE);
//       };

//       p.draw = () => {
//         p.clear();

//         // Calculate the mouse position relative to the parent div
//         const mouseX = p.mouseX - parentBounds.left;
//         const mouseY = p.mouseY - parentBounds.top;

//         // Calculate the row and column of the cell the mouse is currently over
//         const row = p.floor(mouseY / CELL_SIZE);
//         const col = p.floor(mouseX / CELL_SIZE);

//         // Check if the mouse has moved to a different cell
//         if (row !== currentRow || col !== currentCol) {
//           currentRow = row;
//           currentCol = col;
//           // Add new neighbors to the allNeighbors array
//           allNeighbors.push(...getRandomNeighbors(row, col));
//         }

//         // Use the calculated row and column to determine the position of the cell
//         const x = col * CELL_SIZE;
//         const y = row * CELL_SIZE;

//         // Draw a highlighted rectangle over the cell under the mouse cursor
//         p.stroke(colorWithAlpha);
//         p.rect(x, y, CELL_SIZE, CELL_SIZE);

//         // Draw and update all neighbors
//         for (let neighbor of allNeighbors) {
//           const neighborX = neighbor.col * CELL_SIZE;
//           const neighborY = neighbor.row * CELL_SIZE;
//           // Update the opacity of the neighbor
//           neighbor.opacity = Math.max(0, neighbor.opacity - AMT_FADE_PER_FRAME);
//           p.stroke(COLOR_R, COLOR_G, COLOR_B, neighbor.opacity);
//           p.rect(neighborX, neighborY, CELL_SIZE, CELL_SIZE);
//         }
//         // Remove neighbors with zero opacity
//         allNeighbors = allNeighbors.filter((neighbor) => neighbor.opacity > 0);
//       };

//       const getRandomNeighbors = (row, col) => {
//         let neighbors = [];

//         // Loop through the cells surrounding the given cell
//         for (let dRow = -1; dRow <= 1; dRow++) {
//           for (let dCol = -1; dCol <= 1; dCol++) {
//             const neighborRow = row + dRow;
//             const neighborCol = col + dCol;

//             const isCurrentCell = dRow === 0 && dCol === 0;
//             const isInBounds =
//               neighborRow >= 0 &&
//               neighborRow < numRows &&
//               neighborCol >= 0 &&
//               neighborCol < numCols;

//             if (
//               !isCurrentCell &&
//               isInBounds &&
//               Math.random() < PROB_OF_NEIGHBOR
//             ) {
//               neighbors.push({
//                 row: neighborRow,
//                 col: neighborCol,
//                 opacity: 255, // Initial opacity of the neighbor
//               });
//             }
//           }
//         }

//         return neighbors;
//       };

//       p.windowResized = () => {
//         // Update parent bounds and resize canvas
//         const parentDiv = sketchRef.current.parentNode;
//         parentBounds = parentDiv.getBoundingClientRect();

//         p.resizeCanvas(parentBounds.width, parentBounds.height);
//         numRows = Math.ceil(parentBounds.height / CELL_SIZE);
//         numCols = Math.ceil(parentBounds.width / CELL_SIZE);
//       };
//     };

//     const p5Instance = new p5(sketch, sketchRef.current);

//     return () => {
//       p5Instance.remove();
//     };
//   }, []);

//   return <div ref={sketchRef} style={{ position: "relative" }} />;
// };

// export default GridAnimation;

















































// import React, { useEffect, useRef } from "react";
// import p5 from "p5";

// const GridAnimation = () => {
//   const sketchRef = useRef(null);

//   useEffect(() => {
//     const sketch = (p) => {
//       // CONSTANTS
//       const CELL_SIZE = 40; // size of each cell in the grid
//       const COLOR_R = 79;
//       const COLOR_G = 38;
//       const COLOR_B = 233;
//       const STARTING_ALPHA = 200;
//       const PROB_OF_NEIGHBOR = 0.5;
//       const AMT_FADE_PER_FRAME = 5;

//       // VARIABLES
//       let colorWithAlpha;
//       let numRows;
//       let numCols;
//       let currentRow = -2;
//       let currentCol = -2;
//       let allNeighbors = []; // Array to store all neighbors

//       p.setup = () => {
//         const cnv = p.createCanvas(p.windowWidth, p.windowHeight);
//         cnv.style("position", "fixed");
//         cnv.style("inset", 0);
//         cnv.style("z-index", -1);
//         cnv.style("pointer-events", "none"); // Prevent the canvas from interfering with mouse events
//         cnv.style("background", "transparent"); // Make the canvas transparent
//         colorWithAlpha = p.color(COLOR_R, COLOR_G, COLOR_B, STARTING_ALPHA);
//         p.noFill();
//         p.stroke(colorWithAlpha);
//         p.strokeWeight(1);
//         numRows = Math.ceil(p.windowHeight / CELL_SIZE); // number of rows in the grid
//         numCols = Math.ceil(p.windowWidth / CELL_SIZE); // number of columns in the grid
//       };

//       p.draw = () => {
//         p.clear(); // Clear the canvas for the current frame

//         // Calculate the row and column of the cell that the mouse is currently over
//         let row = p.floor(p.mouseY / CELL_SIZE);
//         let col = p.floor(p.mouseX / CELL_SIZE);

//         // Check if the mouse has moved to a different cell
//         if (row !== currentRow || col !== currentCol) {
//           currentRow = row;
//           currentCol = col;
//           // Add new neighbors to the allNeighbors array
//           allNeighbors.push(...getRandomNeighbors(row, col));
//         }

//         // Use the calculated row and column to determine the position of the cell
//         let x = col * CELL_SIZE;
//         let y = row * CELL_SIZE;

//         // Draw a highlighted rectangle over the cell under the mouse cursor
//         p.stroke(colorWithAlpha);
//         p.rect(x, y, CELL_SIZE, CELL_SIZE);

//         // Draw and update all neighbors
//         for (let neighbor of allNeighbors) {
//           let neighborX = neighbor.col * CELL_SIZE;
//           let neighborY = neighbor.row * CELL_SIZE;
//           // Update the opacity of the neighbor
//           neighbor.opacity = Math.max(0, neighbor.opacity - AMT_FADE_PER_FRAME); // Decrease opacity by 5 each frame
//           p.stroke(COLOR_R, COLOR_G, COLOR_B, neighbor.opacity);
//           p.rect(neighborX, neighborY, CELL_SIZE, CELL_SIZE);
//         }
//         // Remove neighbors with zero opacity
//         allNeighbors = allNeighbors.filter((neighbor) => neighbor.opacity > 0);
//       };

//       const getRandomNeighbors = (row, col) => {
//         let neighbors = []; // Initialize an empty array to store neighbor cells

//         // Loop through the cells surrounding the given cell (row, col)
//         for (let dRow = -1; dRow <= 1; dRow++) {
//           for (let dCol = -1; dCol <= 1; dCol++) {
//             // Calculate the neighboring cell's row and column indices
//             let neighborRow = row + dRow;
//             let neighborCol = col + dCol;

//             // Check if the current cell in the loop is the given cell (row, col)
//             let isCurrentCell = dRow === 0 && dCol === 0;

//             // Check if the neighboring cell is within the grid boundaries
//             let isInBounds =
//               neighborRow >= 0 &&
//               neighborRow < numRows &&
//               neighborCol >= 0 &&
//               neighborCol < numCols;

//             // If the cell is not the given cell, is within bounds, and has a 50% chance,
//             // add the neighboring cell to the neighbors array
//             if (
//               !isCurrentCell &&
//               isInBounds &&
//               Math.random() < PROB_OF_NEIGHBOR
//             ) {
//               neighbors.push({
//                 row: neighborRow,
//                 col: neighborCol,
//                 opacity: 255, // Initial opacity of the neighbor
//               });
//             }
//           }
//         }

//         // Return the array of randomly-selected neighboring cells
//         return neighbors;
//       };

//       p.windowResized = () => {
//         p.resizeCanvas(p.windowWidth, p.windowHeight);
//         numRows = Math.ceil(p.windowHeight / CELL_SIZE); // number of rows in the grid
//         numCols = Math.ceil(p.windowWidth / CELL_SIZE); // number of columns in the grid
//       };
//     };

//     const p5Instance = new p5(sketch, sketchRef.current);

//     return () => {
//       p5Instance.remove();
//     };
//   }, []);

//   return <div ref={sketchRef} />;
// };

// export default GridAnimation;








































// import React, { useEffect, useRef } from "react";
// import p5 from "p5";

// const GridAnimation = () => {
//   const sketchRef = useRef(null);

//   useEffect(() => {
//     const sketch = (p) => {
//       // CONSTANTS
//       const CELL_SIZE = 40; // size of each cell in the grid
//       const COLOR_R = 79;
//       const COLOR_G = 38;
//       const COLOR_B = 233;
//       const STARTING_ALPHA = 200;
//       const BACKGROUND_COLOR = 31;
//       const PROB_OF_NEIGHBOR = 0.5;
//       const AMT_FADE_PER_FRAME = 5;

//       // VARIABLES
//       let colorWithAlpha;
//       let numRows;
//       let numCols;
//       let currentRow = -2;
//       let currentCol = -2;
//       let allNeighbors = []; // Array to store all neighbors

//       p.setup = () => {
//         const cnv = p.createCanvas(p.windowWidth, p.windowHeight);
//         cnv.style("position", "fixed");
//         cnv.style("inset", 0);
//         cnv.style("z-index", 100);
//         colorWithAlpha = p.color(COLOR_R, COLOR_G, COLOR_B, STARTING_ALPHA);
//         p.noFill();
//         p.stroke(colorWithAlpha);
//         p.strokeWeight(1);
//         numRows = Math.ceil(p.windowHeight / CELL_SIZE); // number of rows in the grid
//         numCols = Math.ceil(p.windowWidth / CELL_SIZE); // number of columns in the grid
//       };

//       p.draw = () => {
//         p.background(BACKGROUND_COLOR);

//         // Calculate the row and column of the cell that the mouse is currently over
//         let row = p.floor(p.mouseY / CELL_SIZE);
//         let col = p.floor(p.mouseX / CELL_SIZE);

//         // Check if the mouse has moved to a different cell
//         if (row !== currentRow || col !== currentCol) {
//           currentRow = row;
//           currentCol = col;
//           // Add new neighbors to the allNeighbors array
//           allNeighbors.push(...getRandomNeighbors(row, col));
//         }

//         // Use the calculated row and column to determine the position of the cell
//         let x = col * CELL_SIZE;
//         let y = row * CELL_SIZE;

//         // Draw a highlighted rectangle over the cell under the mouse cursor
//         p.stroke(colorWithAlpha);
//         p.rect(x, y, CELL_SIZE, CELL_SIZE);

//         // Draw and update all neighbors
//         for (let neighbor of allNeighbors) {
//           let neighborX = neighbor.col * CELL_SIZE;
//           let neighborY = neighbor.row * CELL_SIZE;
//           // Update the opacity of the neighbor
//           neighbor.opacity = Math.max(0, neighbor.opacity - AMT_FADE_PER_FRAME); // Decrease opacity by 5 each frame
//           p.stroke(COLOR_R, COLOR_G, COLOR_B, neighbor.opacity);
//           p.rect(neighborX, neighborY, CELL_SIZE, CELL_SIZE);
//         }
//         // Remove neighbors with zero opacity
//         allNeighbors = allNeighbors.filter((neighbor) => neighbor.opacity > 0);
//       };

//       const getRandomNeighbors = (row, col) => {
//         let neighbors = []; // Initialize an empty array to store neighbor cells

//         // Loop through the cells surrounding the given cell (row, col)
//         for (let dRow = -1; dRow <= 1; dRow++) {
//           for (let dCol = -1; dCol <= 1; dCol++) {
//             // Calculate the neighboring cell's row and column indices
//             let neighborRow = row + dRow;
//             let neighborCol = col + dCol;

//             // Check if the current cell in the loop is the given cell (row, col)
//             let isCurrentCell = dRow === 0 && dCol === 0;

//             // Check if the neighboring cell is within the grid boundaries
//             let isInBounds =
//               neighborRow >= 0 &&
//               neighborRow < numRows &&
//               neighborCol >= 0 &&
//               neighborCol < numCols;

//             // If the cell is not the given cell, is within bounds, and has a 50% chance,
//             // add the neighboring cell to the neighbors array
//             if (
//               !isCurrentCell &&
//               isInBounds &&
//               Math.random() < PROB_OF_NEIGHBOR
//             ) {
//               neighbors.push({
//                 row: neighborRow,
//                 col: neighborCol,
//                 opacity: 255, // Initial opacity of the neighbor
//               });
//             }
//           }
//         }

//         // Return the array of randomly-selected neighboring cells
//         return neighbors;
//       };

//       p.windowResized = () => {
//         p.resizeCanvas(p.windowWidth, p.windowHeight);
//         numRows = Math.ceil(p.windowHeight / CELL_SIZE); // number of rows in the grid
//         numCols = Math.ceil(p.windowWidth / CELL_SIZE); // number of columns in the grid
//       };
//     };

//     const p5Instance = new p5(sketch, sketchRef.current);

//     return () => {
//       p5Instance.remove();
//     };
//   }, []);

//   return <div ref={sketchRef} />;
// };

// export default GridAnimation;
